<template lang="pug">
  div.PagingToolbar
    template(v-for="(pageNumbers, groupIndex) in pageNumbersGroups")
      div.GroupsSeparator(v-if="groupIndex")
        span ...
      ul.pagination
        li(
          v-for="pageNumber in pageNumbers"
          :class="{ 'active': value === pageNumber }"
        )
          a(@click="goTo(pageNumber)")
            span {{ pageNumber }}

</template>

<script>
    export default {
        name: 'PagingToolbar',
        props: {
            value: {
                type: Number,
                required: true
            },
            pagesCount: {
                type: Number,
                required: true
            }
        },
        computed: {
            /**
             * Для удобства предлагается показывать для выбора страницы группами:
             * [1, 2] ... [n - 1, n, n + 1] ... [max_n - 1, max_n]
             */
            pageNumbersGroups() {
                if (this.pagesCount < 2) {
                    return [];
                }

                const firstGroup = [ 1, 2 ];
                const middleGroup = [ this.value - 1, this.value, this.value + 1 ];
                const lastGroup = [ this.pagesCount - 1, this.pagesCount ];

                const firstGroupLastItem = firstGroup[firstGroup.length - 1];
                const middleGroupLastItem = middleGroup[middleGroup.length - 1];
                if (firstGroupLastItem >= middleGroup[0] && middleGroupLastItem >= lastGroup[0]) {
                    return [ firstGroup.concat(
                        middleGroup.filter(i => i > firstGroupLastItem && i < lastGroup[0])
                    ) ];
                }

                if (firstGroupLastItem >= middleGroup[0]) {
                    return [ firstGroup.concat(
                        middleGroup.filter(i => i > firstGroupLastItem)
                    ), lastGroup ];
                }

                if (middleGroupLastItem >= lastGroup[0]) {
                    return [
                        firstGroup,
                        middleGroup.filter(i => i < lastGroup[0])
                            .concat(lastGroup)
                    ];
                }

                return [ firstGroup, middleGroup, lastGroup ];
            }
        },
        methods: {
            goTo(pageNumber) {
                this.$emit('input', pageNumber);
            }
        }
    };
</script>

<style scoped lang="stylus">
  .PagingToolbar
    user-select: none

  .GroupsSeparator
    display: inline-block
    margin: 20px 15px
    vertical-align: top

    & span
      font-size: 15px
</style>



// WEBPACK FOOTER //
// src/lib/components/PagingToolbar.vue